import { Component, Inject, OnInit, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ApiService } from '../../../providers/api.service';
import { SM_CONSTANTS } from '../../../shared/constants/sm-constants';


@Component({
  selector: 'sm-view-details',
  templateUrl: './view-details.component.html',
  styleUrls: ['./view-details.component.scss']
})
export class ViewDetailsComponent implements OnInit, OnDestroy {  
  imageUrl: string = environment.profileImageBaseUrl;
  metadata: any
  postData: any
  public loader: boolean = false;
  private _apiSubscription: Subscription;
  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private _apiService: ApiService) {

    this._apiSubscription = this._apiService.apiResult.subscribe(resData =>{
      if(resData.responseType === SM_CONSTANTS.GET_REFERRED_USER_DETAILS_RESULT){
      console.log(resData.result);
      resData.result[0].userLocation = JSON.parse(resData.result[0].userLocation)

        this.metadata = resData.result
      
        
      }
      
      this.loader = false;
    });
   }

  ngOnInit(): void {
this.loader = true
this._apiService.getReferredUserDetails(this.data.account_id)
  }


  ngOnDestroy(): void {
    this._apiSubscription.unsubscribe()
  }

}
